<template lang="html">
  <div class="p-3 p-lg-4 text-center" v-if="!$store.state.device || !$store.state.device.object">
    <b-spinner></b-spinner>
    <p class="mt-3">{{ lang === 'ru' ? 'Загрузка...' : 'Завантаження...' }}</p>
  </div>
  <div class="p-3 p-lg-4" v-else-if="$store.state.device && $store.state.device.object">

    <b-breadcrumb
      class="d-lg-none"
      :items="[
        {text: `${$store.state.device.man} № ${$store.state.device.serial_number} - ${lang === 'ru' ? 'Прогноз' : 'Прогноз'}`}
      ]">
    </b-breadcrumb>

    <div class="mb-3 fs-14 d-lg-none">
      <strong>{{
        ['heat_flow_pipe', 'heat_return_pipe'].includes($store.state.device.device_type) ?
          (lang === 'ru' ? 'Теплосчетчик' : 'Теплолічильник')
          :
          (lang === 'ru' ? 'Неизвестное устройство' : 'Невідомий пристрій')
      }}</strong>
      {{ lang === 'ru' ? 'по адресу' : 'за адресою' }}
      {{ lang === 'ru' ? $store.state.device.object.group_name : $store.state.device.object.group_name_ua }}
      {{ lang === 'ru' ? $store.state.device.object.name : $store.state.device.object.name_ua }}
      № {{ $store.state.device.apartment_number }}
      ({{ {'residential': (lang === 'ru' ? 'Жилое' : 'Житлове'), 'commercial': (lang === 'ru' ? 'Коммерческое' : 'Коммерційне')}[$store.state.device.apartment_type] }})
    </div>

    <div class="mb-3 fs-14 fw-700 text-nowrap d-none d-lg-flex">
      <table>
        <tbody>
          <tr>
            <td class="pr-3">{{ lang === 'ru' ? 'Устройство' : 'Пристрій' }}:</td>
            <td class="border-right pr-3">
              {{ ['heat_flow_pipe', 'heat_return_pipe'].includes($store.state.device.device_type) ?
                (lang === 'ru' ? 'Теплосчетчик' : 'Теплолічильник')
                :
                (lang === 'ru' ? 'Неизвестное устройство' : 'Невідомий пристрій')
              }}
            </td>
            <td class="px-3">{{ lang === 'ru' ? 'Объект' : "Об'єкт" }}:</td>
            <td>
              {{ lang === 'ru' ? $store.state.device.object.group_name : $store.state.device.object.group_name_ua }}
              {{ lang === 'ru' ? $store.state.device.object.name : $store.state.device.object.name_ua }}</td>
          </tr>
          <tr>
            <td class="pr-3">{{ lang === 'ru' ? 'Код производителя' : 'Код виробника' }}:</td>
            <td class="border-right pr-3">{{ $store.state.device.man }}</td>
            <td class="px-3">{{ lang === 'ru' ? 'Помещение' : 'Приміщення'}}:</td>
            <td>№ {{ $store.state.device.apartment_number }}</td>
          </tr>
          <tr>
            <td class="pr-3">{{ lang === 'ru' ? 'Серийный номер' : 'Серійний номер'}}:</td>
            <td class="border-right pr-3">{{ $store.state.device.serial_number }}</td>
            <td class="px-3">{{ lang === 'ru' ? 'Тип помещения' : 'Тип приміщення'}}:</td>
            <td>{{ {'residential': (lang === 'ru' ? 'Жилое' : 'Житлове'), 'commercial': (lang === 'ru' ? 'Коммерческое' : 'Коммерційне')}[$store.state.device.apartment_type] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="fw-700 fs-14 d-flex flex-wrap align-items-center mb-3">
      <div class="mr-3 mb-3">
        {{ lang === 'ru' ? 'Начало периода' : 'Початок періоду' }}:
      </div>
      <Datepicker
        v-model="date_from"
        :format="customFormatter"
        @input="setDateFrom"
        :disabled-dates="{
          to: $moment().subtract(1, 'day').toDate()
        }"
        :language="lang === 'ru' ? ru : ua"
        :monday-first="true"
        input-class="form-control bg-transparent border-dark fw-700 fs-14 text-dark mr-4 mb-3"/>

      <div class="mr-3 mb-3">
        {{ lang === 'ru' ? 'Конец периода' : 'Кінець періоду' }}:
      </div>
      <Datepicker
        v-model="date_to"
        :format="customFormatter"
        :disabled-dates="{
          to: date_from,
          from: $moment(date_from).add(1, 'month').toDate()
        }"
        :language="lang === 'ru' ? ru : ua"
        :monday-first="true"
        input-class="form-control bg-transparent border-dark fw-700 fs-14 text-dark mr-4 mb-3"/>

      <router-link :to="`/manager/devices/${$store.state.device.id}`" class="btn btn-sm btn-success mb-3">
        {{ lang === 'ru' ? 'К показаниям' : 'До показань' }}
      </router-link>

    </div>

    <b-tabs
      :small="$store.state.vw < 992"
      pills
      content-class="mt-3"
      @input="tabChanged">

      <b-tab :title="lang === 'ru' ? 'Прогноз' : 'Прогноз'" active>
        <div v-if="loading" class="text-center p-5">
          <b-spinner></b-spinner>
          <p class="mt-3">{{ lang === 'ru' ? 'Загрузка прогноза...' : 'Завантаження прогнозу...' }}</p>
        </div>

        <div v-else-if="error" class="alert alert-danger">
          {{ error }}
        </div>

        <div v-else class="table-responsive">
          <b-table
            id="manager-device-predict-table"
            head-variant="light"
            responsive
            bordered
            small
            :fields="fields"
            :items="predictedData">
            <template #cell(index)="data">
              {{ data.index + 1 }}
            </template>
            <template #cell(date)="data">
              {{ data.item.date | moment('DD.MM.YYYY') }}
            </template>
            <template #cell(de_predicted)="data">
              {{ new Intl.NumberFormat('ua-UA', {minimumFractionDigits: 3}).format(data.item.de_predicted) }}
            </template>
            <template #cell(coast)="data">
              {{ new Intl.NumberFormat('ru-RU', {style: 'currency', currency: 'UAH'}).format(data.item.coast || 0) }}
            </template>
            <template #cell(temperature)="data">
              {{ data.item.temperature }}
            </template>

            <template #custom-foot>
              <b-tr>
                <b-th colspan="2" class="text-right">{{ lang === 'ru' ? 'Сумма' : 'Сума' }}</b-th>
                <b-th class="text-center">
                  {{ new Intl.NumberFormat('ua-UA', {minimumFractionDigits: 3}).format(totalDePredicted) }}
                </b-th>
                <b-th class="text-center">
                  {{ new Intl.NumberFormat('ru-RU', {style: 'currency', currency: 'UAH'}).format(totalCoast) }}
                </b-th>
                <b-th></b-th>
              </b-tr>
            </template>
          </b-table>
        </div>
      </b-tab>

      <b-tab :title="$store.state.vw < 992 ? 'Q, Гкал' : (lang === 'ru' ? 'График прогноза Q, Гкал' : 'Графік прогнозу Q, Гкал')">
        <div class="h-300-px mb-5">
          <apexchart
            v-if="apexchartVisible && predictedData.length > 0"
            type="line"
            :options="getQGraphOptions"
            :key="0"
            :height="300"
            :series="getGraphData">
          </apexchart>
        </div>
        <div class="h-300-px mb-5">
          <apexchart
            v-if="apexchartVisible && predictedData.length > 0"
            type="line"
            :options="getWeatherGraphOptions"
            :key="1"
            :height="300"
            :series="getGraphDataWeather">
          </apexchart>
        </div>
      </b-tab>
    </b-tabs>

  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
const vdp_translation = require('vuejs-datepicker/dist/locale/translations/ru.js')
import vdp_translation_ua from  'vuejs-datepicker/dist/locale/translations/uk'

export default {
  name: 'DevicePredict',

  components: {
    Datepicker
  },

  data () {
    return {
      ru: vdp_translation,
      ua: vdp_translation_ua,
      apexchartVisible: false,
      date_from: this.$moment().toDate(),
      date_to: this.$moment().add(14, 'days').toDate(),
      loading: false,
      error: null,
      predictedData: [],
      weatherData: []
    }
  },

  watch:{
    $route (to) {
      this.$store.commit('setData', {
        attr: 'device',
        value: {
          id: to.params.id
        }
      })
      this.loadDeviceInfo()
    },
    date_from () {
      this.fetchPredictions()
    },
    date_to () {
      this.fetchPredictions()
    }
  },

  computed: {

    fields () {
      return [
        {
          key: 'index',
          label: '№',
          sortable: false
        },
        {
          label: this.lang === 'ru' ? 'Дата' : 'Дата',
          key: 'date',
          sortable: true
        },
        {
          label: 'ΔQ прогноз (Гкал)',
          key: 'de_predicted',
          tdClass: 'bg-deep-heat',
          sortable: true
        },
        {
          label: 'ΔQ (грн)',
          key: 'coast',
          tdClass: 'bg-deep-heat',
          sortable: true
        },
        {
          label: this.lang === 'ru' ? 'Ср. температура (°C)' : 'Ср. температура (°C)',
          key: 'temperature',
          sortable: true
        }
      ]
    },

    lang () {
      return this.$store.state.lang
    },

    totalDePredicted () {
      return this.predictedData.reduce((sum, item) => sum + (item.de_predicted || 0), 0)
    },

    totalCoast () {
      return this.predictedData.reduce((sum, item) => sum + (item.coast || 0), 0)
    },

    getGraphData () {
      return [{
        name: `Q (прогноз)`,
        data: this.predictedData.map(d => parseFloat((d.de_predicted || 0).toFixed(3)))
      }]
    },

    getGraphDataWeather () {
      return [
        {
          name: this.$store.state.lang === 'ru' ? `Средняя температура` : 'Середня температура',
          data: this.predictedData.map(d => d.temperature)
        }
      ]
    },

    getQGraphOptions () {
      return {
        chart: {
          id: 'vuechart-q-predict',
          height: '100%',
        },
        colors: ['#fb881e'],
        stroke: {
          curve: 'smooth',
        },
        markers: {
          size: 3,
        },
        xaxis: {
          categories: this.predictedData.map(d => this.$moment(d.date).format('DD.MM'))
        }
      }
    },

    getWeatherGraphOptions () {
      return {
        chart: {
          id: 'vuechart-w-predict',
          height: '100%',
        },
        colors: ['#21cc46'],
        stroke: {
          curve: 'smooth',
        },
        markers: {
          size: 1,
        },
        xaxis: {
          categories: this.predictedData.map(d => this.$moment(d.date).format('DD.MM'))
        }
      }
    }
  },

  methods: {

    customFormatter (date) {
      return this.$moment(date).format('DD.MM.YYYY');
    },

    setDateFrom () {
      if (
        this.$moment(this.date_to) > this.$moment(this.date_from).add(1, 'month') ||
        this.$moment(this.date_to) < this.$moment(this.date_from)
      ) {
        this.date_to = this.$moment(this.date_from).add(14, 'days').toDate()
      }
    },

    tabChanged () {
      this.apexchartVisible = false
      setTimeout(() => {
        this.apexchartVisible = true
      }, 100)
    },

    async loadDeviceInfo () {
      try {
        // Use store action to load device with object
        await this.$store.dispatch('getDeviceData')
      } catch (e) {
        console.error('Error loading device:', e)
      }
    },

    async fetchPredictions () {
      this.loading = true
      this.error = null
      this.predictedData = []

      try {
        const dateFrom = this.$moment(this.date_from).format('YYYY-MM-DD')
        const dateTo = this.$moment(this.date_to).format('YYYY-MM-DD')

        // Step 1: Get weather forecast
        const weatherResponse = await this.$http.get('/api/weather/forecast/', {
          params: {
            from: dateFrom,
            to: dateTo
          }
        })

        if (!weatherResponse.data.success) {
          throw new Error(weatherResponse.data.error || 'Failed to load weather')
        }

        this.weatherData = weatherResponse.data.data

        // Step 2: Prepare records for MLP prediction
        const records = this.weatherData.map((weather, index) => ({
          id: index,
          date: weather.date,
          temperature: weather.temperature,
          wind_speed: weather.wind_speed,
          wind_direction: weather.wind_direction,
          precipitation: weather.precipitation,
          pressure: weather.pressure,
          humidity: weather.humidity,
          uv_index: weather.uv_index
        }))

        // Step 3: Get MLP predictions
        const predictionResponse = await this.$http.post('/api/mlp/predict/', {
          device_id: this.$store.state.device.id,
          records: records
        })

        if (!predictionResponse.data.success) {
          throw new Error(predictionResponse.data.error || 'Failed to get predictions')
        }

        const predictions = predictionResponse.data.predictions

        // Step 4: Combine weather and predictions
        this.predictedData = this.weatherData.map((weather, index) => {
          const de_predicted = predictions[index] || 0
          const coast = de_predicted * (this.$store.state.device.object?.heat_tariff || 0)

          return {
            date: weather.date,
            de_predicted: de_predicted,
            coast: coast,
            temperature: weather.temperature,
            weather_source: weather.source
          }
        })

      } catch (error) {
        console.error('Error fetching predictions:', error)
        this.error = error.message || 'Ошибка загрузки прогноза'
        this.$toasted.error(this.error)
      } finally {
        this.loading = false
      }
    }

  },

  async mounted () {
    try {
      this.$store.commit('mergeStore', {
        device: {
          id: this.$route.params.id
        },
        loading: true
      })

      await this.loadDeviceInfo()
      await this.fetchPredictions()

    } catch (e) {
      this.$toasted.error(`${e.name}: ${e.message}`, {duration: 1000})
    }
  }
}
</script>

<style lang="scss">
.vdp-datepicker{
  input{
    width: 120px;
  }
}

#manager-device-predict-table{
  td{
    width: 20%;
    text-align: center;
  }
}
</style>
